// extracted by mini-css-extract-plugin
export default {"container":"_940bt","row":"ZgCc2","rowRight":"Ft4RB","rowLeft":"TgPR-"};